import { Column } from "../../../../../components/TableDataGridV2/types";
import { IDataListaTitulosPagar } from "../../../../../types/api/financeiro/pesquisar-titulos-pagar";

export const headCellsTitulosPagar: Column<IDataListaTitulosPagar>[] = [
    {
        id: 'tipo_documento',
        label: 'Tipo',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'numero_documento',
        label: 'Número',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'sequencia_documento',
        label: 'Seq.',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'serie_documento',
        label: 'Série',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'data_emissao',
        label: 'Emissão',
        type: "date",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'data_vencimento',
        label: 'Vencimento',
        type: "date",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'valor_pagar',
        label: 'Valor original',
        type: "monetary",
        numeric: true,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'saldo_principal',
        label: 'Saldo',
        type: "monetary",
        numeric: true,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'tipo_publico',
        label: 'Público',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'codigo_publico',
        label: 'Código',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'nome_publico',
        label: 'Nome',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'conta_contabil',
        label: 'Conta Contábil',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'observacoes',
        label: 'Observações',
        type: "text",
        numeric: false,
        filter: false,
        minWidth: 120,
    },
    {
        id: 'historico',
        label: 'Histórico',
        type: "text",
        numeric: true,
        filter: true,
        minWidth: 120,
    },
];

export const headCellsTitulosPagarApGlobal: Column<IDataListaTitulosPagar>[] = [
    {
        id: 'tipo_documento',
        label: 'Tipo',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'numero_documento',
        label: 'Número',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'sequencia_documento',
        label: 'Seq.',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'serie_documento',
        label: 'Série',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'conta_contabil',
        label: 'Conta Contábil',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'data_emissao',
        label: 'Emissão',
        type: "date",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'data_vencimento',
        label: 'Vencimento',
        type: "date",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'valor_pagar',
        label: 'Valor original',
        type: "monetary",
        numeric: true,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'saldo_principal',
        label: 'Saldo',
        type: "monetary",
        numeric: true,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'tipo_publico',
        label: 'Público',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'codigo_publico',
        label: 'Código',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'nome_publico',
        label: 'Nome',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'observacoes',
        label: 'Observações',
        type: "text",
        numeric: false,
        filter: false,
        minWidth: 120,
    },
    {
        id: 'historico',
        label: 'Histórico',
        type: "text",
        numeric: true,
        filter: true,
        minWidth: 120,
    },
];

export const headCellsTitulosPagarCompensacao: Column<IDataListaTitulosPagar>[] = [
    {
        id: 'tipo_documento',
        label: 'Tipo',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'numero_documento',
        label: 'Número',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'sequencia_documento',
        label: 'Seq.',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'serie_documento',
        label: 'Série',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'data_emissao',
        label: 'Emissão',
        type: "date",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'data_vencimento',
        label: 'Vencimento',
        type: "date",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'valor_pagar',
        label: 'Valor original',
        type: "monetary",
        numeric: true,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'saldo_principal',
        label: 'Saldo',
        type: "monetary",
        numeric: true,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'tipo_publico',
        label: 'Público',
        type: "text",
        numeric: false,
        filter: false,
        minWidth: 120,
    },
    {
        id: 'codigo_publico',
        label: 'Código',
        type: "text",
        numeric: false,
        filter: false,
        minWidth: 120,
    },
    {
        id: 'nome_publico',
        label: 'Nome',
        type: "text",
        numeric: false,
        filter: false,
        minWidth: 120,
    },
    {
        id: 'conta_contabil',
        label: 'Conta Contábil',
        type: "text",
        numeric: false,
        filter: true,
        minWidth: 120,
    },
    {
        id: 'observacoes',
        label: 'Observações',
        type: "text",
        numeric: false,
        filter: false,
        minWidth: 120,
    },
    {
        id: 'historico',
        label: 'Histórico',
        type: "text",
        numeric: true,
        filter: true,
        minWidth: 120,
    },
];